import React from 'react';
import './Input.css';

function Input({
  label,
  type = 'text',
  name,
  id,
  value,
  onChange,
  placeholder,
  autoComplete,
  required,
  className = '',
  glass = false,
}) {
  const inputId = id || name || ('input-' + Math.random().toString(36).slice(2, 9));
  const inputClassName = 'ui-input' + (glass ? ' ui-input--glass' : '') + (className ? ' ' + className : '');

  return (
    <div className="ui-input-wrap">
      {label && (
        <label htmlFor={inputId} className="ui-input-label">
          {label}
          {required && <span className="ui-input-required" aria-hidden="true"> *</span>}
        </label>
      )}
      <input
        id={inputId}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        required={required}
        className={inputClassName}
      />
    </div>
  );
}

export default Input;
